/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import Grid from '@material-ui/core/Grid';
import { object, string, array } from 'prop-types';

const PageHeading = ({
    classes, headingTitle, titleFontColor, subTitle, listItem,
}) => (
    <Grid container className={classes.container}>
        <Grid item xs={12} className={classes.headingBlock}>
            <div>
                <h1 className={classes.heading1Title} style={{ color: `${titleFontColor}` }}>World Flowers<sup><small>&trade;</small></sup></h1>
                <h2 className={classes.heading2Title} style={{ color: `${titleFontColor}` }}>{headingTitle}<br /><small> - Your premier provider of flowers and gifts worldwide </small></h2>
                <div className={classes.headingSubTitle}>{subTitle}</div>
            </div>
            <div className={classes.listBlock}>
                <ul>
                    {listItem.map((list, i)  => (
                        <li className={classes.listItem} key={['_', i].join('')}>{list}</li>
                    ))}
                </ul>
            </div>

        </Grid>
    </Grid>
);

PageHeading.propTypes = {
    classes: object.isRequired,
    headingTitle: string.isRequired,
    titleFontColor: string.isRequired,
    subTitle: string.isRequired,
    listItem: array.isRequired,
};

export default PageHeading;
